
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  name: 'OfflineModal',
  components: {
    KeyenceHTHardKeyButton,
  },
})
export default class OfflineModal extends Vue {
  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }

  isOnline = true
  showOfflineDialog = false

  mounted() {
    this.updateOnlineStatus()
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  }

  unmounted() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  }

  updateOnlineStatus() {
    const previousStatus = this.isOnline
    this.isOnline = navigator.onLine

    // Show dialog when going offline
    if (previousStatus && !this.isOnline) {
      this.showOfflineDialog = true
    }

    // Auto-close dialog when back online
    if (!previousStatus && this.isOnline) {
      this.showOfflineDialog = false
    }
  }

  closeDialog() {
    this.showOfflineDialog = false
  }
}
